/* istanbul ignore file */
import { logger } from '@elparking/utils'

function loadFont(name, urls, values) {
  if (typeof FontFace === typeof undefined) {
    return
  }
  urls.forEach((fontInfo) => {
    const font = new FontFace(
      name,
      `url(${fontInfo.url}) format('${fontInfo.format}')`,
      {
        ...values,
        display: 'swap',
      }
    )
    font
      .load()
      .then(() => {
        document.fonts.add(font)
      })
      .catch((error) => {
        logger.error(`Theme can't load ${name} from ${fontInfo.url}`, error)
      })
  })
}

function loadDefinition(name, definitions) {
  definitions.forEach(({ urls, ...values }) => {
    try {
      loadFont(name, urls, values)
    } catch (error) {
      logger.error(`Error loading ${name} font`, error)
    }
  })
}

const loadFonts = (theme) => {
  if (theme.fontFaces) {
    const fonts = Object.keys(theme.fontFaces)
    fonts.forEach((fontName) => {
      if (!window.loadedFonts || !window.loadedFonts.includes(fontName)) {
        window.loadedFonts = window.loadedFonts
          ? [...window.loadedFonts, fontName]
          : [fontName]
        loadDefinition(fontName, theme.fontFaces[fontName])
      }
    })
  } else {
    logger.error('Error: fontFaces not defined in theme')
  }
}

export default loadFonts
